import { useTranslation } from "react-i18next";
import { useMemo, useState } from "react";
import styles from "./AuthPanel.module.css";


export default function AuthPanel({ onLogin }) {
    const { t } = useTranslation();
    const [loading, setLoading] = useState(false);
    const [formError, setFormError] = useState("");
    const [touched, setTouched] = useState(false);
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [show, setShow] = useState(false);

    const errors = useMemo(() => {
        const v = { username: "", password: "" };
        if (!username) v.username = "auth.error.required";
        if (!password) v.password = "auth.error.required";
        else if (password.length < 8) v.password = "auth.error.passwordTooShort";
        return v;
    }, [username, password]);

    const hasErrors = errors.username || errors.password;

    async function handleLogin(payload) {
        setFormError("");
        setLoading(true);
        try {
            await onLogin(payload);
        } catch (e) {
            setFormError(e?.message || "Nie udało się zalogować.");
        } finally {
            setLoading(false);
        }
    }

    function handleSubmit(e) {
        e.preventDefault();
        setTouched(true);
        if (hasErrors) return;
        handleLogin({ username, password });
    }


    return (
        <div className={styles.wrapper}>
            <div className={styles.card} aria-busy={loading ? "true" : "false"}>
                <div className={styles.content}>
                    <form className={styles.form} onSubmit={handleSubmit} noValidate>
                        <div className={styles.field}>
                            <label htmlFor="login-username" className={styles.label}>{t("auth.username", { defaultValue: "Login" })}</label>
                            <input
                                id="login-username"
                                type="text"
                                autoComplete="username"
                                className={`${styles.input} ${touched && errors.username ? styles.inputError : ""}`}
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                                aria-invalid={touched && !!errors.username}
                            />
                            {touched && errors.username && <p className={styles.errorMsg}>{t(errors.username)}</p>}
                        </div>

                        <div className={styles.field}>
                            <label htmlFor="login-password" className={styles.label}>{t("auth.password")}</label>
                            <div className={styles.passwordWrap}>
                                <input
                                    id="login-password"
                                    type={show ? "text" : "password"}
                                    autoComplete="current-password"
                                    className={`${styles.input} ${touched && errors.password ? styles.inputError : ""}`}
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    aria-invalid={touched && !!errors.password}
                                />
                                <button
                                    type="button"
                                    className={styles.togglePwd}
                                    onClick={() => setShow((s) => !s)}
                                >
                                    {show ? t("auth.hidePassword") : t("auth.showPassword")}
                                </button>
                            </div>
                            {touched && errors.password && <p className={styles.errorMsg}>{t(errors.password)}</p>}
                        </div>

                        <button type="submit" className={styles.submitBtn} disabled={loading || (touched && hasErrors)}>
                            {loading ? t("auth.loading") : t("auth.loginButton")}
                        </button>
                    </form>

                    {formError && <div className={styles.formError}>{formError}</div>}
                </div>
            </div>
        </div>
    );
}
